import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const HireCompanyRenderer = ({ data }) => {
  const { colors } = useTheme();
  const hire = data?.original;

  if (hire?.isSkeleton) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={48}
        viewBox="0 0 400 48"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="8" y="16" rx="3" ry="3" width="100" height="12" />
      </ContentLoader>
    );
  }

  if (!hire?.organization) {
    return '';
  }

  const { organization } = hire;

  return (
    <Flex p="8px" alignItems="center" sx={{ height: '100%', gap: '4px' }}>
      <Box width="16px" height="16px" flex="0 0 auto">
        <ProfilePicture
          sx={{
            minWidth: '16px',
            minHeight: '16px',
          }}
          variant="square"
          imageUrl={organization.logoUrl || ''}
          name={organization.name || ''}
        />
      </Box>
      <Text
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {organization.name}
      </Text>
    </Flex>
  );
};

HireCompanyRenderer.propTypes = {
  data: PropTypes.object,
};

HireCompanyRenderer.defaultProps = {
  data: {},
};
